module.exports = __webpack_public_path__ + "img/project-5.664d1433.png";